export const MORNING_STAR_CATEGORY_KEY = 'base' as const;
export const MORNING_STAR_COMPONENT_KEY = 'morningStar' as const;
